import { FC, useLayoutEffect, useRef } from 'react';
import { Toast, ToastMessage, ToastPassThroughOptions } from 'primereact/toast';
import { useAppSelector } from 'src/hooks';
import { getToastNotificationsCurrentMessageSelector } from 'src/redesign/features/Toast/store/selectors';
import styles from './Toast.module.scss';
import toastSuccessIcon from 'src/redesign/assets/icons/toast-success-icon.svg';
import toastFailedIcon from 'src/redesign/assets/icons/toast-failed-icon.svg';
import { Text } from '@components/Text';

export type ToastProps = {
  description?: string;
  position?: string;
} & ToastMessage;

const ToastContent: FC<ToastProps> = ({ detail, severity, description }) => {
  const isSuccess = severity === 'success';
  return (
    <div className={styles.toast}>
      {isSuccess ? (
        <img src={toastSuccessIcon} alt="success" />
      ) : (
        <img src={toastFailedIcon} alt="failed" />
      )}
      <div className={styles.message}>
        <div className={styles.title}>{isSuccess ? 'Success!' : 'Failed'}</div>
        <div className={styles.description}>{detail}</div>
        <Text variation="caption">{description}</Text>
      </div>
    </div>
  );
};
const toastPtOptions: ToastPassThroughOptions = {
  root: {
    style: {
      boxShadow: 'none !important',
      padding: '0',
      opacity: '1',
      background: 'transparent',
    },
  },
  content: {
    style: {
      padding: '0',
      border: 'none',
      boxShadow: 'none',
    },
  },
};

export const ToastNotifications = () => {
  const toastRef = useRef<Toast>(null);
  const currentMessage = useAppSelector(getToastNotificationsCurrentMessageSelector);

  useLayoutEffect(() => {
    if (!currentMessage) return;

    toastRef.current.show({
      ...currentMessage,
      closable: false,

      icon: () =>
        currentMessage.severity === 'success' ? (
          <img src={toastSuccessIcon} alt="success" />
        ) : (
          <img src={toastFailedIcon} alt="failed" />
        ),
      content: (props) => (
        <ToastContent detail={props.message.detail} severity={currentMessage.severity} />
      ),
    });
  }, [currentMessage]);

  return (
    <Toast
      pt={toastPtOptions}
      className={styles.toastWrapper}
      baseZIndex={999999}
      position={currentMessage?.position || 'bottom-right'}
      ref={toastRef}
    />
  );
};
